import { useEnsureTickersLoaded } from "../../../hooks/useEnsureTickersLoaded";
import ColoredTag from "../../../components/ColoredTag";
import { Col, Row } from "antd";
import ViewableResponse from "../../../components/ViewableResponse";
import React from "react";
import { OpenAIOutlined } from "@ant-design/icons";
import Plot from "react-plotly.js";

// Helper function to format data for Plotly Treemap
const formatDataForTreemap = (snapshot, colorMap) => {
  let labels = [];
  let parents = [];
  let values = [];
  let colors = [];

  for (let ticker in snapshot) {
    if (snapshot[ticker].wgt > 0) {
      labels.push(ticker.toUpperCase());
      parents.push(""); // No hierarchy for now, all are root nodes
      values.push((snapshot[ticker].wgt * 100).toFixed(2));
      colors.push(colorMap[ticker] || "#ccc"); // Default color if not in colorMap
    }
  }

  return { labels, parents, values, colors };
};

const BlotterSnapshot = ({ data, colorMap }) => {
  const { snapshot } = data;
  const { labels, parents, values, colors } = formatDataForTreemap(snapshot, colorMap);
  const snapshotData = Object.entries(snapshot)
    .map(([ticker, details], index) => ({
      key: index,
      ticker,
      weight: details.wgt,
      value: details.val,
    }))
    .sort((a, b) => b.weight - a.weight);

  const filteredSnapshotData = snapshotData.filter((d) => d.weight > 0);
  const uniqueTickers = new Set(filteredSnapshotData.map((d) => d.ticker));
  useEnsureTickersLoaded(Array.from(uniqueTickers));

  return (
    <Row align={"middle"}>
      <Col span={12} className={"px-6"}>
        <ViewableResponse
          markdownText={data.text.content}
          title={
            <span>
              <OpenAIOutlined /> {data.text.title}
            </span>
          }
        />
      </Col>
      <Col span={12}>
        <Row align={"middle"} justify={"center"} wrap={false}>
          <div style={{ height: 400, width: 600 }} className={"mx-3"}>
            <Plot
              data={[
                {
                  type: "treemap",
                  labels: labels,
                  parents: parents,
                  values: values,
                  marker: { colors: colors },
                  textinfo: "label+value",
                  hoverinfo: "label+value+percent entry",
                },
              ]}
              layout={{
                margin: { l: 10, r: 10, t: 10, b: 10 },
                showlegend: false,
              }}
              useResizeHandler={true}
              style={{ width: "100%", height: "100%" }}
              config={{ displayModeBar: false }}
            />
          </div>
        </Row>
        <Row align={"middle"} wrap={false}>
          <Col flex={"auto"} className={"px-4"}></Col>
          <Col flex={"0 0 175px"}></Col>
        </Row>
      </Col>
    </Row>
  );
};

export default BlotterSnapshot;